import(/* webpackMode: "eager", webpackExports: ["ReportViewer"] */ "/vercel/path0/src/app/report/[id]/report-viewer.tsx");
